import { render, staticRenderFns } from "./ChatBoxOptions.vue?vue&type=template&id=e2a502a0&scoped=true&"
import script from "./ChatBoxOptions.vue?vue&type=script&lang=js&"
export * from "./ChatBoxOptions.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxOptions.vue?vue&type=style&index=0&id=e2a502a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a502a0",
  null
  
)

export default component.exports